import React, { useEffect } from 'react';

import { isEmpty } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';

import { redirectToOfferOrderRemove, redirectToOfferRemove } from '../../actions';
import { MAIN_PATH } from '../../pages/Main';

import { OFFER_ORDERS_PATH } from './NewOfferOrderGuard';

export const CanActivateSummaryGuard = () => {
  const dispatch = useDispatch();
  const redirectToOfferOrder: string[] = useSelector((state: any) => state.app.redirectToOfferOrder?.data);
  const redirectToOffer: string[] = useSelector((state: any) => state.app.redirectToOffer?.data);
  const redirectToEmailConfirm: { confirm: string; updateId: number } | null = useSelector(
    (state: any) => state.app.redirectToEmailConfirm,
  );

  useEffect(() => {
    return () => {
      // TODO: clear the redirect state in the offer order details page
      if (!isEmpty(redirectToOfferOrder)) {
        dispatch(redirectToOfferOrderRemove());
      }

      //TODO: clear the redirect state in the offer details page
      if (!isEmpty(redirectToOffer)) {
        dispatch(redirectToOfferRemove());
      }
    };
  }, []);

  if (redirectToOfferOrder && redirectToOfferOrder.length === 1) {
    return <Navigate to={`/${MAIN_PATH}/${OFFER_ORDERS_PATH}/${redirectToOfferOrder[0]}/orders/new`} />;
  }

  if (redirectToEmailConfirm) {
    const { confirm, updateId } = redirectToEmailConfirm;

    return <Navigate to={`/email-confirm?confirm=${confirm}&id=${updateId}`} />;
  }

  if (redirectToOffer && redirectToOffer.length === 1) {
    return <Navigate to={`/offers/${redirectToOffer[0]}`} />;
  }

  return <Outlet />;
};
